import { createContext, useContext } from 'react';

export enum MessageType {
  INFO = 'INFO',
  ERROR = 'ERROR',
}

type AppContextType = {
  message?: string;
  messageType?: MessageType;
  displayToastMessage: (message: string, messageType?: MessageType) => void;
  hideMessages: () => void;
};

const initialType: AppContextType = {
  displayToastMessage: (message: string) => {},
  hideMessages: () => {},
};

export const AppNotificationContext = createContext(initialType);

export const useAppNotification = () => useContext(AppNotificationContext);